<template>
    <div class="index_body" id="top" :class="isPhone == 'true' ? 'mobile' : ''">
        <head-nav></head-nav>
        <div class="notic_box">
            <el-card class="box-card">
                <div class="clearfix">
                    <span>安全公告</span>
                </div>
            </el-card>
            <el-card class="box-card notic_main">
                <el-table :data="tableData" :show-header="false" style="width: 100%" @row-click="pinSelect">
                    <el-table-column prop="title" width="1000">
                    </el-table-column>
                    <el-table-column prop="time" align="right">
                    </el-table-column>
                </el-table>
            </el-card>
        </div>
        <customer-service></customer-service>
        <footer-nav></footer-nav>
    </div>
</template>

<script>
import footerNav from "@comm/components/document-conversion/footerPage";
import headNav from "@comm/components/document-conversion/headerPage";
import customerService from "@comm/components/document-conversion/customerService";
export default {
    components: { footerNav, customerService, headNav },
    name: "announcement",
    data() {
        return {
            isPhone: false,
            /* tableData: [
                { title: '数科OFD文档处理软件V3.0漏洞修复公告', time: '2022/10/14', id:"2022101401" },
                { title: '官网数科OFD版式软件V5.0漏洞修复公告', time: '2023/09/14', id:"2023091401" },
            ] */
        };
    },
    created() {
        this.isPhone = localStorage.getItem("isPhone");
        document.title = "安全公告";
    },
    mounted() {
    },
    watch: {
    },
    computed: {
        tableData() {
            return this.$store.state.announcementList
        }
    },
    methods: {
        pinSelect(row) {
            const { href } = this.$router.resolve({
                path: '/details/' + row.id,
                query: {url:row.url}
			});
			window.open(href, "_blank");
        }
    }
};
</script>
<style lang="scss" scoped>
.index_body {
    width: 100%;
    padding-top: 72px;
    display: flex;
    flex-direction: column;
    height: 100%;

    .notic_box {
        width: 1200px;
        margin: 40px auto;
        flex: 1;
        display: flex;
    flex-direction: column;
        .box-card {
            margin: 20px 0;

            .clearfix span {
                font-size: 16px;
                font-weight: 600;
            }
            &.notic_main{
                flex: 1;
            }
        }
    }

}
</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/announcement/index.vue